import {
  ViewStaticGroup,
  AddMembers,
  EditMembers,
} from 'pages/SettingsPage/modals/GroupsModal/views/static';
import { EditGroup, NewGroup } from 'pages/SettingsPage/modals/GroupsModal/views';
import { QUERY_settingsGroupDetails } from 'queries';
import { StaticGroup, DynamicGroup } from 'types/graphql';
import {
  SelectCriteria,
  ViewDynamicGroup,
} from 'pages/SettingsPage/modals/GroupsModal/views/dynamic';
import { createApolloClient } from 'providers/ApolloProvider';
import { ISSFBehaviorsOptions } from 'hooks/useSSFBehaviors/useSSFBehaviors.types';
import { InMemoryCache, Reference } from '@apollo/client';

export const GroupsDetailsComponentMap = {
  NewGroup,
  ViewStaticGroup,
  ViewDynamicGroup,
  EditGroup,
  AddMembers,
  EditMembers,
  SelectCriteria,
  EditCriteria: SelectCriteria,
};
export type GroupsDetailsModalViewType = keyof typeof GroupsDetailsComponentMap;

const groupsApolloClient = createApolloClient({
  cache: new InMemoryCache({
    typePolicies: {
      Query: {
        fields: {
          node: {
            keyArgs: ['id'],
          },
        },
      },
      StaticGroup: {
        fields: {
          groupJanes: {
            keyArgs: false,
            merge(existing = { nodes: [] }, incoming = { nodes: [] }, { readField }) {
              const mergedNodes = [...existing.nodes];

              incoming.nodes.forEach((incomingNode: Reference) => {
                const incomingId = readField('id', incomingNode);
                if (!mergedNodes.some((node) => readField('id', node) === incomingId)) {
                  mergedNodes.push(incomingNode);
                }
              });

              return {
                ...incoming,
                nodes: mergedNodes,
              };
            },
          },
        },
      },
    },
  }),
});

export const fetchGroupConfig = (groupId: string): ISSFBehaviorsOptions => {
  return {
    key: 'FETCH_GROUP_DETAILS_QUERY',
    query: QUERY_settingsGroupDetails,
    pageSize: 20,
    paginationType: 'InfiniteScroll',
    schema: {
      id: {
        initialValue: groupId,
      },
    },
    client: groupsApolloClient,
    responseTransformer: (data) => data?.node as StaticGroup | DynamicGroup,
  };
};
